const lowColumns = [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'deviceCode',
    key: 'deviceCode',
    width: 280
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 360
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 160
  },
  {
    zh: '平均压力(Mpa)',
    en: 'Average Pressure(Mpa)',
    dataIndex: 'avgPressure',
    key: 'avgPressure',
    tooltip: true
  },
  {
    zh: '平均温度(℃)',
    en: 'Average Temperature(℃)',
    dataIndex: 'avgTemperature',
    key: 'avgTemperature',
    tooltip: true
  },
  {
    zh: '平均频率(Hz)',
    en: 'Average Frequency(Hz)',
    dataIndex: 'avgFrequency',
    key: 'avgFrequency',
    tooltip: true
  },
  {
    zh: '设定压力(Mpa)',
    en: 'Rated Pressure(Mpa)',
    dataIndex: 'ratedPressure',
    key: 'ratedPressure',
    tooltip: true
  },
  {
    zh: '上限频率(Hz)',
    en: 'Upper Limit Frequency(Hz)',
    dataIndex: 'upperLimitFrequency',
    key: 'upperLimitFrequency',
    tooltip: true
  },
  {
    zh: '下限频率(Hz)',
    en: 'Lower Limit Frequency(Hz)',
    dataIndex: 'lowerLimitFrequency',
    key: 'lowerLimitFrequency',
    tooltip: true
  },
  {
    zh: '低频率',
    en: 'Percentage',
    dataIndex: 'percentage',
    key: 'percentage',
    fixed: 2,
    tooltip: true
  }
]

export {
  lowColumns
}
